import SrDialogSelect from "./index.vue";

SrDialogSelect.install = function(Vue) {
  Vue.component(SrDialogSelect.name, SrDialogSelect);
};

export default SrDialogSelect;



// WEBPACK FOOTER //
// ./packages/SrDialogSelect/index.js